import { createContext } from "react";

const CityContext = createContext({
    city: {},
})

export default CityContext;